module.exports = __webpack_public_path__ + "static/media/icon_footer_facebook.f8ef74c6.svg";